import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { compose } from 'recompose';
import { first } from 'lodash';

import * as styles from './styles.css';
import * as sharedStyles from '../styles.css';
import formControl from '../formControl';
import Option from './Option';

class RichSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      autoselect: props.autoselect,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { autoselect, isLoading, input, autodeselect } = this.props;

    if (autoselect !== nextProps.autoselect) {
      this.setState({ autoselect: nextProps.autoselect });
    }

    if (this.state.autoselect
      && isLoading
      && !nextProps.isLoading
      && (nextProps.input.value === undefined || nextProps.input.value === '')
    ) {
      if (nextProps.options.length === 1) {
        nextProps.input.onChange(first(nextProps.options).value);
      }

      // Only once
      this.setState({ autoselect: false });
    }

    if (autodeselect && nextProps.input.value && !nextProps.isLoading) {
      if (nextProps.multi) {
        // Note: TODO.
      } else if (!nextProps.options.some(
        option => String(option.value) === String(nextProps.input.value),
      )) {
        input.onChange(null);
      }
    }
  }

  handleChange = selected => this.props.input.onChange(selected ? selected.value : null);

  handleBlur = () => this.props.input.onBlur(this.props.input.value);

  render() {
    const {
      onChangeText,
      disabled,
      placeholder,
      renderValue,
      renderOption,
      options,
      input,
      isLoading,
      filterOption,
      clearable,
    } = this.props;



    return (
      <div className={styles.container}>
        <Select
          onInputChange={onChangeText}
          disabled={disabled}
          placeholder={placeholder}
          name="search"
          autoload={false}
          valueRenderer={renderValue}
          optionRenderer={renderOption}
          options={options}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={input.value}
          className={`${sharedStyles.inputContainer} ${styles.inputContainer}`}
          isLoading={isLoading}
          filterOption={filterOption}
          clearable={clearable}
        />
      </div>
    );
  }
}

RichSelect.propTypes = {
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
  })).isRequired,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string, // Just a side effect of redux-form initializing to string
      PropTypes.object,
      PropTypes.number,
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
  }).isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  autoselect: PropTypes.bool,
  onChangeText: PropTypes.func,
  renderOption: PropTypes.func,
  renderValue: PropTypes.func,
  autodeselect: PropTypes.bool,
  clearable: PropTypes.bool,
  multi: PropTypes.bool,
  filterOption: PropTypes.func,
};

RichSelect.defaultProps = {
  disabled: false,
  multi: false,
  autoselect: false,
  clearable: true,
  autodeselect: true, // When true, sets current value to null if not part of options
  onChangeText: undefined,
  renderOption: Option,
  renderValue: Option,
  filterOption: () => true,
};

export default compose(formControl)(RichSelect);
